export const timeOfLogin = () => {
  var dateInput = new Date();
  var timeInput = dateInput.toLocaleString().split(",")[1].split(" ");

  return timeInput[1];
};

export const getTimeDiff = () => {
  const startTime = sessionStorage.getItem("timeoflogin").split(":");
  const endTime = timeOfLogin().split(":");

  // console.log("--startTime", startTime, endTime);
  const today = new Date();
  const yyyy = today.getFullYear();
  let mm = today.getMonth() + 1; // Months start at 0!
  let dd = today.getDate();

  if (dd < 10) dd = "0" + dd;
  if (mm < 10) mm = "0" + mm;

  //button.addEventListener("click", function () {
  let startDate = new Date(
    yyyy,
    mm,
    parseInt(dd),
    startTime[0],
    startTime[1],
    startTime[2]
  );
  let endDate = new Date(
    yyyy,
    mm,
    parseInt(dd),
    endTime[0],
    endTime[1],
    endTime[2]
  );
  let difference = endDate.getTime() - startDate.getTime();
  let diffArray = [];
  if (difference < 0) {
    // output.innerHTML = "Wow dude, you just went back to the future! 👽";
  } else {
    difference = difference / 1000;
    let hourDifference = Math.floor(difference / 3600);
    difference -= hourDifference * 3600;
    let minuteDifference = Math.floor(difference / 60);
    difference -= minuteDifference * 60;

    // console.log(
    //   "--in seconds hours",
    //   hourDifference,
    //   minuteDifference,
    //   difference
    // );
    // if (hourDifference === 0) {
    // console.log("--in seconds", difference);

    diffArray[0] = hourDifference;
    diffArray[1] = minuteDifference;
    diffArray[2] = difference;
    // }
  }
  console.log("--diff", diffArray);
  return diffArray;
};
